import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=d5091254&scoped=true"
var script = {}
import style0 from "./contact.vue?vue&type=style&index=0&id=d5091254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5091254",
  null
  
)

export default component.exports